<template>
  <div class="aiCompany CompanyHome">
    <Header></Header>
    <div class="CompanyHomeBg2">
      <img alt="" src="@a/aicompany/images/bg2.jpg" />
    </div>
    <div class="CompanyDigitalAssets">
      <div class="CompanyDigitalAssets_top hover">
        <div class="CompanyDigitalAssets_top_title">
          <div class="top_title_list"><img alt="" src="@a/aicompany/images/bn2.png" /><span>企业数字资产包，一键开通</span><img alt="" src="@a/aicompany/images/bn3.png" /></div>
          <div class="top_title_list">市场价</div>
          <div class="top_title_list"><img alt="" src="@a/aicompany/images/bn4.png" />AIDOG</div>
        </div>
        <div class="CompanyDigitalAssets_top_txt">
          <div class="top_txt_list">
            <div class="txt_list_li">
              <div class="list_li_title">企业开办</div>
              <div class="list_li_content">
                <div class="li_content_l">
                  <div class="content_l_dd"><img alt="" src="@a/aicompany/images/sv15.svg" />公司核名</div>
                  <div class="content_l_dt">不限次数公司核名</div>
                </div>
                <div class="li_content_l">
                  <div class="content_l_dd"><img alt="" src="@a/aicompany/images/sv16.svg" />公司章程</div>
                  <div class="content_l_dt">专业人员撰写公司章程</div>
                </div>
                <div class="li_content_l">
                  <div class="content_l_dd"><img alt="" src="@a/aicompany/images/sv17.svg" />营业执照办理</div>
                  <div class="content_l_dt">专业人员撰写公司章程</div>
                </div>
                <div class="li_content_l">
                  <div class="content_l_dd"><img alt="" src="@a/aicompany/images/sv18.svg" />刻章</div>
                  <div class="content_l_dt">公章刻制</div>
                </div>
                <div class="li_content_l">
                  <div class="content_l_dd"><img alt="" src="@a/aicompany/images/sv19.svg" />银行开户</div>
                  <div class="content_l_dt">银行基本户开具</div>
                </div>
              </div>
            </div>
            <div class="txt_list_li MarketPrice">￥2000.00</div>
            <div class="txt_list_li color">￥0元</div>
          </div>
          <div class="top_txt_list">
            <div class="txt_list_li">
              <div class="list_li_title">财税申报</div>
              <div class="list_li_content">
                <div class="li_content_l">
                  <div class="content_l_dd"><img alt="" src="@a/aicompany/images/sv20.svg" />记账报税</div>
                  <div class="content_l_dt">专业财务老师对接</div>
                </div>
                <div class="li_content_l">
                  <div class="content_l_dd"><img alt="" src="@a/aicompany/images/sv21.svg" />汇算清缴</div>
                  <div class="content_l_dt">税款汇总结算清缴工作</div>
                </div>
                <div class="li_content_l">
                  <div class="content_l_dd"><img alt="" src="@a/aicompany/images/sv22.svg" />代开发票</div>
                  <div class="content_l_dt">企业代表发票</div>
                </div>
                <div class="li_content_l">
                  <div class="content_l_dd"><img alt="" src="@a/aicompany/images/sv23.svg" />工商年检</div>
                  <div class="content_l_dt">提供工商年检服务</div>
                </div>
                <div class="li_content_l">
                  <div class="content_l_dd"><img alt="" src="@a/aicompany/images/sv24.svg" />财税筹划</div>
                  <div class="content_l_dt">专业财税老师提供财税规划</div>
                </div>
              </div>
            </div>
            <div class="txt_list_li MarketPrice">￥3600.00</div>
            <div class="txt_list_li color">￥1980.00</div>
          </div>
          <div class="top_txt_list">
            <div class="txt_list_li">
              <div class="list_li_title">企业文案</div>
              <div class="list_li_content">
                <div class="li_content_l">
                  <div class="content_l_dd"><img alt="" src="@a/aicompany/images/sv25.svg" />公司介绍PPT</div>
                  <div class="content_l_dt">人工+AI生成公司介绍PPT</div>
                </div>
                <div class="li_content_l">
                  <div class="content_l_dd"><img alt="" src="@a/aicompany/images/sv26.svg" />企业文化</div>
                  <div class="content_l_dt">企业愿景、使命价值观</div>
                </div>
              </div>
            </div>
            <div class="txt_list_li MarketPrice">￥2000.00</div>
            <div class="txt_list_li color">￥0元</div>
          </div>
          <div class="top_txt_list">
            <div class="txt_list_li">
              <div class="list_li_title">品牌数字化VI</div>
              <div class="list_li_content">
                <div class="li_content_l">
                  <div class="content_l_dd"><img alt="" src="@a/aicompany/images/sv27.svg" />LOGO设计</div>
                  <div class="content_l_dt">基于AIDOG的LOGO智能生成100张</div>
                </div>
                <div class="li_content_l">
                  <div class="content_l_dd"><img alt="" src="@a/aicompany/images/sv28.svg" />VI</div>
                  <div class="content_l_dt">生成企业VI使用规范</div>
                </div>
                <div class="li_content_l">
                  <div class="content_l_dd"><img alt="" src="@a/aicompany/images/sv29.svg" />名片设计</div>
                  <div class="content_l_dt">基于AIDOG的名片智能设计</div>
                </div>
              </div>
            </div>
            <div class="txt_list_li MarketPrice">￥6000.00</div>
            <div class="txt_list_li color">￥180.00</div>
          </div>
          <div class="top_txt_list">
            <div class="txt_list_li">
              <div class="list_li_title">品牌互联网体系建设（官网+PC+手机+公众号+企业邮箱）</div>
              <div class="list_li_content">
                <div class="li_content_l">
                  <div class="content_l_dd"><img alt="" src="@a/aicompany/images/sv30.svg" />PC官网</div>
                  <div class="content_l_dt">企业官网建设</div>
                </div>
                <div class="li_content_l">
                  <div class="content_l_dd"><img alt="" src="@a/aicompany/images/sv31.svg" />手机网站</div>
                  <div class="content_l_dt">自动适应移动端</div>
                </div>
                <div class="li_content_l">
                  <div class="content_l_dd"><img alt="" src="@a/aicompany/images/sv32.svg" />公众号搭建</div>
                  <div class="content_l_dt">微信公众号搭建</div>
                </div>
                <div class="li_content_l">
                  <div class="content_l_dd"><img alt="" src="@a/aicompany/images/sv33.svg" />域名注册</div>
                  <div class="content_l_dt">提供国际顶级域名注册</div>
                </div>
                <div class="li_content_l">
                  <div class="content_l_dd"><img alt="" src="@a/aicompany/images/sv34.svg" />网站主机</div>
                  <div class="content_l_dt">提供10GB超大容量网站主机</div>
                </div>
                <div class="li_content_l">
                  <div class="content_l_dd"><img alt="" src="@a/aicompany/images/sv35.svg" />ICP备案</div>
                  <div class="content_l_dt">提供网站ICP备案服务</div>
                </div>
                <div class="li_content_l">
                  <div class="content_l_dd"><img alt="" src="@a/aicompany/images/sv36.svg" />SSL证书</div>
                  <div class="content_l_dt">提供网站SSL证书，网站数据加密传输</div>
                </div>
                <div class="li_content_l">
                  <div class="content_l_dd"><img alt="" src="@a/aicompany/images/sv37.svg" />企业邮箱</div>
                  <div class="content_l_dt">提供10个用户的网站企业邮箱</div>
                </div>
              </div>
            </div>
            <div class="txt_list_li MarketPrice">￥20000.00</div>
            <div class="txt_list_li color">￥3980.00</div>
          </div>
          <div class="top_txt_list sem">
            <div class="txt_list_li">
              <div class="list_li_title">营销推广</div>
              <div class="list_li_content">
                <div class="li_content_l">
                  <div class="content_l_dd"><img alt="" src="@a/aicompany/images/sv38.svg" />软文写作</div>
                  <div class="content_l_dt">
                    <p>• 提供100篇AIDOG软文</p>
                    <p>• 自动发布到网站上面</p>
                  </div>
                </div>
                <div class="li_content_l">
                  <div class="content_l_dd"><img alt="" src="@a/img/logo2.png" />提供100篇AIDOG软文</div>
                  <div class="content_l_dt">
                    <p><img alt="" src="@a/aicompany/images/bn5.png" /></p>
                    <p>将您的公司宣传软文发布到6大主流媒体门户官网，增强品牌宣传。</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="txt_list_li MarketPrice">￥4000.00</div>
            <div class="txt_list_li color">￥860.00</div>
          </div>
          <div class="top_txt_list total">
            <div class="txt_list_li">
              <div class="list_li_dd">总计</div>
            </div>
            <div class="txt_list_li MarketPrice"><b>￥37600.00</b></div>
            <div class="txt_list_li color">
              <p><b>￥7000.00</b></p>
            </div>
            <p class="txt_list_bottom1">为您节省<b>30600</b>元</p>
            <p class="txt_list_bottom">产品开通以后有专业客户经理为您提供一对一的服务</p>
          </div>
        </div>
      </div>
      <div class="CompanyDigitalAssets_bottom">
        <div class="CompanyDigitalAssets_bottom_title"><img alt="" src="@a/aicompany/images/bn2.png" /><span>AI-DOG如何为您创造价值</span><img alt="" src="@a/aicompany/images/bn3.png" /></div>
        <div class="CompanyDigitalAssets_bottom_txt">
          <div class="bottom_txt_bg"><img alt="" src="@a/aicompany/images/bg3.jpg" /></div>
          <div class="bottom_txt_list">
            <div class="txt_list_title">传统数字资产</div>
            <div class="txt_list_content">
              <div class="list_content_li">
                <div class="content_li_icon"><img alt="" src="@a/aicompany/images/bn6.png" /></div>
                <div class="content_li_txt">
                  <div class="li_txt_dd"> 多方对接</div>
                  <div class="li_txt_dt">分别与多个供应商对接，节省时间和精力。</div>
                </div>
              </div>
              <div class="list_content_li">
                <div class="content_li_icon"><img alt="" src="@a/aicompany/images/bn7.png" /></div>
                <div class="content_li_txt">
                  <div class="li_txt_dd">高昂单项服务费</div>
                  <div class="li_txt_dt">传统方式需要为每项服务分别支付费用。</div>
                </div>
              </div>
              <div class="list_content_li">
                <div class="content_li_icon"><img alt="" src="@a/aicompany/images/bn8.png" /></div>
                <div class="content_li_txt">
                  <div class="li_txt_dd">质量参差不齐</div>
                  <div class="li_txt_dt">传统方式不同供应商提供的服务质量可能参差不齐</div>
                </div>
              </div>
              <div class="list_content_li">
                <div class="content_li_icon"><img alt="" src="@a/aicompany/images/bn9.png" /></div>
                <div class="content_li_txt">
                  <div class="li_txt_dd">高运营复杂度</div>
                  <div class="li_txt_dt">传统方式通常需要企业手动管理多个供应商，运营复杂度较高。</div>
                </div>
              </div>
              <div class="list_content_li">
                <div class="content_li_icon"><img alt="" src="@a/aicompany/images/bn10.png" /></div>
                <div class="content_li_txt">
                  <div class="li_txt_dd">传统手工服务</div>
                  <div class="li_txt_dt">传统方式则依赖人工完成所有任务，效率较低且缺乏创新。</div>
                </div>
              </div>
              <div class="list_content_li">
                <div class="content_li_icon"><img alt="" src="@a/aicompany/images/bn11.png" /></div>
                <div class="content_li_txt">
                  <div class="li_txt_dd">服务覆盖单一环节</div>
                  <div class="li_txt_dt">传统方式一般只能提供某一环节的服务，缺乏一站式的全面保障。</div>
                </div>
              </div>
            </div>
          </div>
          <div class="bottom_txt_list">
            <div class="txt_list_title"><img alt="" src="@a/aicompany/images/bn18.png" /></div>
            <div class="txt_list_content">
              <div class="list_content_li">
                <div class="content_li_icon"><img alt="" src="@a/aicompany/images/bn12.png" /></div>
                <div class="content_li_txt">
                  <div class="li_txt_dd">一站式服务</div>
                  <div class="li_txt_dt">AIDOG平台通过一站式服务整合所有企业需求</div>
                </div>
              </div>
              <div class="list_content_li">
                <div class="content_li_icon"><img alt="" src="@a/aicompany/images/bn13.png" /></div>
                <div class="content_li_txt">
                  <div class="li_txt_dd">成本更低</div>
                  <div class="li_txt_dt">AIDOG平台通过整合服务和AI技术，大幅降低成本</div>
                </div>
              </div>
              <div class="list_content_li">
                <div class="content_li_icon"><img alt="" src="@a/aicompany/images/bn14.png" /></div>
                <div class="content_li_txt">
                  <div class="li_txt_dd">服务质量保障</div>
                  <div class="li_txt_dt">AIDOG平台通过AI技术和数据支持保障服务质量的一致性</div>
                </div>
              </div>
              <div class="list_content_li">
                <div class="content_li_icon"><img alt="" src="@a/aicompany/images/bn15.png" /></div>
                <div class="content_li_txt">
                  <div class="li_txt_dd">降低运营复杂度</div>
                  <div class="li_txt_dt">AIDOG平台通过自动化和智能化减少了企业在运营过程中需要管理的复杂环节</div>
                </div>
              </div>
              <div class="list_content_li">
                <div class="content_li_icon"><img alt="" src="@a/aicompany/images/bn16.png" /></div>
                <div class="content_li_txt">
                  <div class="li_txt_dd">AI驱动创新</div>
                  <div class="li_txt_dt">AIDOG平台运用先进的AI技术，不仅提高了效率，还推动了服务创新</div>
                </div>
              </div>
              <div class="list_content_li">
                <div class="content_li_icon"><img alt="" src="@a/aicompany/images/bn17.png" /></div>
                <div class="content_li_txt">
                  <div class="li_txt_dd">服务覆盖全程</div>
                  <div class="li_txt_dt">AIDOG平台提供从公司开办到日常运营的全程服务</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="CompanyDigitalAssets_bottom_title"><img alt="" src="@a/aicompany/images/bn2.png" /><span>AIDOG-推动AI赋能企业</span><img alt="" src="@a/aicompany/images/bn3.png" /></div>
      </div>
    </div>
    <div class="CompanyDigitalAssets_empowerment hover">
      <div class="CompanyDigitalAssets_empowerment_top">
        <div
          class="empowerment_top_list_wrapper"
          ref="marqueeWrapper"
          @mouseover="pauseMarquee"
          @mouseleave="startMarquee"
        >
          <div class="empowerment_top_list" ref="marquee1">
            <div
              v-for="(item, index) in line1"
              :key="'line1-' + index"
              class="top_list_li"
            >
              {{ item }}
            </div>
            <!-- 克隆第一行 -->
            <div
              v-for="(item, index) in line1"
              :key="'clone-line1-' + index"
              class="top_list_li"
            >
              {{ item }}
            </div>
          </div>
          <div class="empowerment_top_list" ref="marquee2">
            <div
              v-for="(item, index) in line2"
              :key="'line2-' + index"
              class="top_list_li"
            >
              {{ item }}
            </div>
            <!-- 克隆第二行 -->
            <div
              v-for="(item, index) in line2"
              :key="'clone-line2-' + index"
              class="top_list_li"
            >
              {{ item }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="CompanyDigitalAssets_customer hover" ref="customerMarqueeWrapper">
      <div
        class="CompanyDigitalAssets_customer_list_wrapper"
        @mouseover="pauseMarquee"
        @mouseleave="startMarquee"
      >
        <div class="CompanyDigitalAssets_customer_list" ref="customerMarquee">
          <div v-for="(item, index) in customers" :key="index" class="customer_list">
            <div class="customer_list_left">
              <img :alt="item.name" :src="item.img" />
            </div>
            <div class="customer_list_right">
              <div class="list_right_dd">{{ item.name }}</div>
              <div class="list_right_dt">{{ item.feedback }}</div>
            </div>
          </div>
          <!-- 克隆一遍内容 -->
          <div v-for="(item, index) in customers" :key="'clone-' + index" class="customer_list">
            <div class="customer_list_left">
              <img :alt="item.name" :src="item.img" />
            </div>
            <div class="customer_list_right">
              <div class="list_right_dd">{{ item.name }}</div>
              <div class="list_right_dt">{{ item.feedback }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="ActivateNow">
      <div class="ActivateNow_content">
        <div class="ActivateNow_left"><img alt="" src="@a/aicompany/images/bn19.png" />AI-DOG-站式打包<span>A革命一价全包，省时!省钱!省力!</span></div>
        <div class="ActivateNow_right" @click="showPreview = !showPreview">立即开通<i class="el-icon-arrow-right"></i></div>
      </div>
    </div>



    <div class="Discount" v-show="showDiscount">
      <div class="DiscountBg">
        <div class="Discount_content">
          <div class="Discount_content_top">
            <div class="content_top_left">
              <div class="top_left_dd">AIDOG大额优惠券</div>
              <div class="top_left_dt">
                <span>0{{ hours }}</span>:<span>0{{ minutes }}</span>:<span>{{ seconds }}</span>后失效
              </div>
            </div>
            <div class="content_top_close" @click="showDiscount = !showDiscount"><img alt="" src="@a/img/closeon.svg" /></div>
          </div>
          <div class="Discount_content_con">
            <div class="Discount_content_center">
              <div class="content_center_icon content_center_icon1"></div>
              <div class="content_center_icon content_center_icon2"></div>
              <div class="content_center_left"><span>￥</span><b>1200</b></div>
              <div class="content_center_right">开通企业数字资产包立减</div>
            </div>
            <div class="Discount_content_btn" @click="showDiscount = !showDiscount">立即使用</div>
          </div>
        </div>
      </div>
    </div>



    
    <div class="Preview" v-show="showPreview">
      <div class="Preview_content">
        <div class="Preview_content_title">
          <div class="content_title_left"><span></span>企业数字资产包一键开通</div>
          <div class="content_title_right" @click="showPreview = !showPreview"><i class="el-icon-close"></i></div>
        </div>
        <div class="Preview_content_txt2">
          <div class="content_txt2_top">
            <div class="txt2_top_left"><img :alt="products.name" :src="products.images" /></div>
            <div class="txt2_top_right">
              <div class="top_right_dd">￥{{products.money}}<span>原价￥7000.00</span></div>
              <div class="top_right_p">限时特惠<b>立减1200元</b>，优惠仅剩<span>0{{ hours }}</span>:<span>0{{ minutes }}</span>:<span>{{ seconds }}</span></div>
              <div class="top_right_dt">
                <div class="right_dt_list"><span><img alt="" src="@a/aicompany/images/sv8.svg" /><img alt="" src="@a/aicompany/images/sv9.svg" /></span>请用支付宝/微信扫码支付</div>
                <div class="right_dt_list">费用支付完成以后我们会按排专人和您联系开通相关产品和业务。</div>
              </div>
            </div>
          </div>
          <div class="content_txt2_bottom">发票申请：您可以点击<span @click="handleClick">"发票申请"</span>来在线开具电子发票</div>
        </div>
      </div>
    </div>

    <a href="https://affim.baidu.com/unique_57216128/chat?siteId=21467967&userId=57216128&siteToken=9f9b60f596a10c1b494ba79f8f356e69&cp=&cr=&cw=AI%E5%85%AC%E5%8F%B8%E8%B5%B7%E5%90%8D%E6%95%B0%E5%AD%97%E8%B5%84%E4%BA%A7%E5%8C%85%E8%B4%AD%E4%B9%B0%E5%92%A8%E8%AF%A2" target="_blank" class="OConsultation">
      <img alt="" src="@a/img/sv2_1.svg" /><img alt="" src="@a/img/sv2_2.svg" />在线咨询
    </a>


  </div>
</template>

<script>
import Header from '@c/aiCompanyheader/aiCompanyheader'


export default {
  name: 'CompanyDigitalAssets',
  data() {
    return {
      showPreview: true,
      showDiscount: true,
      line1: [
        "AIDOG，您的高效AI助手",
        "国家高薪技术企业奖",
        "AIDOG加速产业数字化转型",
        "科技型中小企业",
        "全场景人工智能解决方案",
        "Z世代的数字助手",
        "上海市软件行业协会",
        "AI图像识别与视觉智能",
        "人工智能辅助创意设计",
      ],
      line2: [
        "数字化艺术与AI创作工具",
        "数字艺术与内容创作",
        "金牌网站设计奖",
        "人工智能深度训练",
        "AI驱动数字革命",
        "个性化智能推荐",
        "AI提升企业运营效率与成本控制",
        "增强创新创意",
        "大数据驱动智能决策",
      ],
      scrollPosition1: 0,
      scrollPosition2: 0,
      animationFrame: null,
      customers: [
        {
          name: "@Z先生 - 物流公司：",
          feedback: "AIDOG真的是我们公司的数字营销神器！软文生成功能太方便了，省去了不少内容创作的时间，让我能专注于业务发展。强烈推荐！",
          img: require('@a/img/img/1.png'),
          
        },
        {
          name: "@李小姐 - 财务公司：",
          feedback: "用了AIDOG的AI公司核名功能，简直太省心了！不仅帮我们快速找到合适的公司名字，还能自动检查是否符合相关法规，一步到位。",
          img: require('@a/img/img/2.png'),
          
        },
        {
          name: "王经理 - 教育培训公司",
          feedback: "AIDOG的AI生成logo功能太棒了！只需要输入一些基本信息，它就能快速给出几个非常有创意的方案，节省了很多设计时间。",
          img: require('@a/img/img/3.png'),
          
        },
        {
          name: "张总 - 咨询公司",
          feedback: "AI网站建设功能非常强大，AIDOG快速帮我们设计了一个符合公司定位的网站，界面简洁、功能全面，效果远超我们的预期！",
          img: require('@a/img/img/4.png'),
          
        },
        {
          name: "陈小姐 - 餐饮公司",
          feedback: "AIDOG的AI生成企业VI功能真是太智能了！根据我们餐饮品牌的特点，迅速生成了完整的视觉识别系统，让品牌形象统一又突出。",
          img: require('@a/img/img/5.png'),
          
        },
        {
          name: "林先生 - 电子商务公司",
          feedback: "AIDOG不仅在生成软文方面效率高，内容质量也非常出色。每次用它写营销文章，都能精确抓住客户需求，提升了我们的推广效果。",
          img: require('@a/img/img/6.png'),
          
        },
        {
          name: "刘经理 - 互联网公司",
          feedback: "AIDOG的AI公司核名工具，不仅提供了创意十足的名字，还能快速检测是否存在重复或侵权问题。这个功能太实用了！",
          img: require('@a/img/img/7.png'),
          
        },
        {
          name: "孙总 - 房地产公司",
          feedback: "AI生成logo和VI真的很快，而且效果超乎预期！AIDOG不仅提升了我们的品牌形象，也节省了很多设计的成本和时间。",
          img: require('@a/img/img/8.png'),
          
        },
        {
          name: "黄小姐 - 教育机构",
          feedback: "用了AIDOG后，软文的创作效率提高了不少。它能够根据我们的需求生成不同风格的文章，让我们的推广效果变得更加精准。",
          img: require('@a/img/img/9.png'),
          
        },
        {
          name: "赵经理 - 制造公司",
          feedback: "AIDOG的AI网站建设功能太实用了，界面设计简洁清晰，后台操作也非常直观，完全不需要专业的技术团队就能做出高质量网站。",
          img: require('@a/img/img/10.png'),
          
        },
        {
          name: "周先生 - 科技公司",
          feedback: "AIDOG的AI生成logo工具非常适合创业公司，简单几步就能得到符合公司文化的logo设计，省时又省力。",
          img: require('@a/img/img/11.png'),
          
        },
        {
          name: "朱小姐 - 医疗行业",
          feedback: "AI生成的企业VI设计很符合我们的品牌形象，整个设计过程也非常快捷，完全不需要担心设计上的细节问题。",
          img: require('@a/img/img/1.png'),
          
        },
        {
          name: "钱经理 - 互联网营销公司",
          feedback: "AIDOG真是一个不可多得的营销工具，特别是在生成软文和广告文案上非常高效。它帮助我们节省了大量时间，内容质量也更有吸引力。",
          img: require('@a/img/img/12.png'),
          
        },
        {
          name: "郭总 - 零售公司",
          feedback: "AIDOG的AI公司核名功能真是太棒了，自动生成的名字不仅创意十足，而且符合品牌定位，帮我们省去了找命名公司的一大笔费用。",
          img: require('@a/img/img/13.png'),
          
        },
        {
          name: "吴小姐 - 创意设计公司",
          feedback: "我们公司之前一直依赖外包设计，但自从用上AIDOG后，AI生成的logo和VI设计简直超乎我们的想象，完全符合品牌定位！",
          img: require('@a/img/img/1.png'),
          
        },
        {
          name: "蒋先生 - 物流公司",
          feedback: "AIDOG帮助我们迅速构建了公司网站，所有功能都很完善，客户反馈也很好。通过AIDOG，线上展示效果大大提升！",
          img: require('@a/img/img/2.png'),
          
        },
        {
          name: "范总 - 营销公司",
          feedback: "AIDOG的软文生成工具能根据我们的行业特点快速生成内容，而且文案非常有创意。每次做推广时，都能省心不少。",
          img: require('@a/img/img/3.png'),
          
        },
        {
          name: "李总 - 教育平台",
          feedback: "AI网站建设功能让我们的官网焕然一新，整个设计和开发过程非常高效，简直不敢相信是AI自动完成的！",
          img: require('@a/img/img/4.png'),
          
        },
        {
          name: "林小姐 - 婴幼儿用品公司",
          feedback: "用了AIDOG的AI公司核名工具，结果超出预期！它不仅帮我们找到了一个独特的名字，还提供了商标注册的建议，非常贴心。",
          img: require('@a/img/img/5.png'),
          
        },
        {
          name: "张小姐 - 金融公司",
          feedback: "AIDOG的AI生成logo功能简直太方便了，几分钟就能得出多个符合公司理念的设计方案，而且每一个都很有创意，省去了我们找设计师的时间。",
          img: require('@a/img/img/6.png'),
          
        },
      ],
      customerScrollPosition: 0,
      customerAnimationFrame: null,
      products: [], // 产品列表
      pollingInterval: null, // 保存轮询的 interval ID
      totalSeconds: 600, // 总秒数，这里设置为 09:59:00 对应的秒数
      hours: 0,
      minutes: 0,
      seconds: 0
    };
  },
  created() {

  },
  components: {
    Header
  },
  watch: {
    // 监听 showPreview 状态
    showPreview(newValue) {
      if (newValue) {
        this.startPolling(); // 开始轮询
      } else {
        this.stopPolling(); // 停止轮询
      }
    },
  },
  methods: {
    //倒计时
    startCountdown() {
      const interval = setInterval(() => {
        if (this.totalSeconds > 0) {
          this.totalSeconds--;
          this.hours = Math.floor(this.totalSeconds / 3600);
          this.minutes = Math.floor((this.totalSeconds % 3600) / 60);
          this.seconds = this.totalSeconds % 60;
        } else {
          clearInterval(interval);
        }
      }, 1000);
    },
    startMarquee() {
      const list1 = this.$refs.marquee1;
      const list2 = this.$refs.marquee2;
      const marquee = this.$refs.customerMarquee;
      const step = 0.5; // 每帧移动像素数

      const scroll = () => {
        this.scrollPosition1 -= step;
        this.scrollPosition2 -= step;
        this.customerScrollPosition -= step;
        // 当滚动到内容末尾时重置位置
        if (-this.scrollPosition1 >= list1.scrollWidth / 2) {
          this.scrollPosition1 = 0;
        }
        if (-this.scrollPosition2 >= list2.scrollWidth / 2) {
          this.scrollPosition2 = 0;
        }
        if (-this.customerScrollPosition >= marquee.scrollWidth / 2) {
          this.customerScrollPosition = 0;
        }
        list1.style.transform = `translateX(${this.scrollPosition1}px)`;
        list2.style.transform = `translateX(${this.scrollPosition2}px)`;
        marquee.style.transform = `translateX(${this.customerScrollPosition}px)`;
        this.animationFrame = requestAnimationFrame(scroll);
      };

      this.animationFrame = requestAnimationFrame(scroll);
    },
    pauseMarquee() {
      cancelAnimationFrame(this.animationFrame);
      this.animationFrame = null;
    },

    async fetchProductList() {
      try {
        const response = await this.axios.get("/api/products/getAiCompanyList");
        if (response.code === 1) {
          this.products = response.result[0];
        } else {
          console.error("获取产品列表失败:", response.data.msg);
        }
      } catch (error) {
        console.error("接口请求错误:", error);
      }
    },

    startPolling() {
      // 每隔 3 秒调用一次接口
      this.pollingInterval = setInterval(async () => {
        try {
          const response = await this.axios.get("/api/pointOrder/hasNewOrder");
          if (response.code === 1 && response.result === true ) {
            this.handlePaymentSuccess();
          }
        } catch (error) {
          console.error("轮询接口出错：", error);
        }
      }, 3000);
    },
    stopPolling() {
      // 停止轮询
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    },
    handlePaymentSuccess() {
      // 停止轮询并关闭弹窗
      this.stopPolling();
      this.showPreview = false;
      this.$message.success("支付成功！");
    },

    handleClick() {
      // 跳转到目标链接
      window.open(`https://www.ai-dog.net/member/#/integral/rechargeDetails`, "_blank");
    },

  },

  mounted() {
    this.startCountdown();
    this.startMarquee();
    this.fetchProductList(); // 页面加载时获取产品列表
    // 初始化时根据 showPreview 状态处理
    if (this.showPreview) {
      this.startPolling();
    }
  },
  beforeUnmount() {
    this.pauseMarquee();
  },
  beforeDestroy() {
    // 清理轮询以防止内存泄漏
    this.stopPolling();
  },
}


</script>

<style>
@import "CompanyDigitalAssets.css";
</style>
